import {Section, SectionItem} from './types';
import {Position} from './constants';
/**
 * Finds selected items on sections
 */
export function findSelectedItems<T = any>(
  sections: Section[],
  predicate: (item: SectionItem) => boolean = (item) => item.isSelected,
): Array<SectionItem<T>> {
  const selection = new Set<SectionItem>();

  for (const section of sections) {
    if (section.items) {
      for (const item of section.items) {
        if (predicate(item)) {
          selection.add(item);
        }
      }
    }
  }

  return Array.from(selection);
}

export function itemHasSubSections(item: SectionItem) {
  return item?.subSections?.some(isPopulatedSection);
}

export function isPopulatedSection(section: Section) {
  return section.items.length || section.isLoading;
}

/**
 * Determines screen position relative to an element based on screen dimensions
 */
export function alignDropdown(parentRect: DOMRect, containerRect: DOMRect, verticalOffset = 0) {
  let verticalPosition = Position.TOP;
  let horizontalPosition = Position.RIGHT;
  const overflowsHorizontally = parentRect.right + containerRect.width >= window.innerWidth;
  const overflowsVertically = parentRect.top + containerRect.height + verticalOffset >= window.innerHeight;
  const isPastMidPoint = parentRect.left >= window.innerWidth / 2;

  // if container overflows vertically
  if (overflowsVertically) {
    verticalPosition = Position.BOTTOM;
  }

  if (overflowsHorizontally || isPastMidPoint) {
    horizontalPosition = Position.LEFT;
  }

  return {horizontal: horizontalPosition, vertical: verticalPosition};
}
